import { configureStore } from "@reduxjs/toolkit"; // import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./reducer.js";
var store = configureStore({ reducer: rootReducer, middleware: function middleware(getDefaultMiddleware) { return getDefaultMiddleware({ thunk: true, serializableCheck: false }); } });
export default store;
